// extracted by mini-css-extract-plugin
export default {"Content":"BaseReason_Content__tgXuB","IconWrapper":"BaseReason_IconWrapper__j7ede"};